var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper_wap"},[_c('el-carousel',{attrs:{"interval":3000,"arrow":"always","autoplay":true}},_vm._l((_vm.$t('WapTopMenuBarData')),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"carousel_img",attrs:{"src":item.imgUrl},on:{"click":function($event){return _vm.goto(item.goto)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }